import { Client } from 'src/constants';

// Mirrors the order used by the company detail clients sidebar:
//   group order: not invited (0) -> invited (1) -> active/confirmed (2)
//   within group: updatedDate desc
export function sortCompanyClients(clients: Client[]): Client[] {
  const getGroupOrder = (client: Client) => {
    if (client.fields.userStatus === 'CONFIRMED') return 2;
    if (client.fields.invitedBy) return 1;
    return 0;
  };

  return [...clients].sort((a, b) => {
    const groupOrderA = getGroupOrder(a);
    const groupOrderB = getGroupOrder(b);
    if (groupOrderA !== groupOrderB) {
      return groupOrderA - groupOrderB;
    }
    return (
      new Date(b.updatedDate).getTime() - new Date(a.updatedDate).getTime()
    );
  });
}
